export const GET_INTERNAL_SEARCH_REQUESTED  = 'GET_INTERNAL_SEARCH_REQUESTED';
export const GET_INTERNAL_SEARCH_SUCCESS    = 'GET_INTERNAL_SEARCH_SUCCESS';
export const GET_INTERNAL_SEARCH_FAILED     = 'GET_INTERNAL_SEARCH_FAILED';
export const RESET_INTERNAL_SEARCH          = 'RESET_INTERNAL_SEARCH';
